<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Vehicle Request" />



        <div class="container-fluid" v-if="isMobileView()">

            <div class="col-xxl-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                            data-original-title="test" data-bs-target="#vehicalReqAdd">Create Vehicle Request</button>
                    </div> -->
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active  nav-border txt-danger nav-danger" id="requested-tab"
                                    data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested"
                                    aria-selected="false"><i class="icofont icofont-file-document"></i>Today</a>
                            </li>
                            <li class="nav-item"><a class="nav-linknav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a></li>
                            <!--<li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger"-->
                            <!--        id="completed-gatepass-tab" data-bs-toggle="tab" href="#completed-gatepass"-->
                            <!--        role="tab" aria-controls="completed-gatepass" aria-selected="false"><i-->
                            <!--            class="icofont icofont-star"></i>Completed</a></li>-->
                            <li>
                                <button class="btn btn-primary" type="button" data-bs-toggle="modal"
                                    data-original-title="test" data-bs-target="#vehicalReqAdd">ADD</button>
                            </li>
                        </ul>
                        
                        <div class="tab-content" id="topline-tabContent">
                            <!-- All Vehicle Requests Card View -->
                            <div class="tab-pane fade" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">
                                    <!-- <div class="col-12 row">
                                        <div class="col-3">
                                            <label class="form-label">From Date</label>
                                            <input class="form-control" type="date" v-model="filter.fromdate"
                                                placeholder="Type Here..." required="">
                                        </div>
                                        <div class="col-3">
                                            <label class="form-label">To Date</label>
                                            <input class="form-control" type="date" v-model="filter.todate"
                                                placeholder="Type Here..." required="">
                                        </div>
                                        <div class="col-3 mt-4">
                                            <button class="btn btn-primary">Filter</button>
                                        </div>
                                    </div> -->
                    
                                    <div class="user-header pb-2 mt-2">
                                      <h6 class="fw-bold">All</h6> 
                                           <div class="form-group d-flex align-items-center pb-2 gap-2">
                                          <input
                                            type="text"
                                            v-model="search_text_all"
                                            class="form-control"
                                            placeholder="Search..."
                                          />
                                        
                                          &nbsp; <span @click=" filterlist();" class="badge bg-danger text-white"> Filter </span>
                                         
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6" v-for="(item, index) in filterd_request" :key="item.gatepassid">
                                            <div class="card mb-3"  :class="{
                                                    'pass_card-warning':item.approval_status==0 || item.approval_status==7,
                                                    'pass_card-success': item.approval_status==1 || item.approval_status==2 || item.approval_status==3,
                                                    'pass_card-danger':item.approval_status==4 || item.approval_status==5 || item.approval_status==6
                                                }">
                                                <div class="card-header" :class="{
                                                    'bg-warning': item.approval_status==0 || item.approval_status==7,
                                                    'bg-success': item.approval_status==1 || item.approval_status==2 || item.approval_status==3,
                                                    'bg-danger': item.approval_status==4 || item.approval_status==5 || item.approval_status==6
                                                }">
                                                    <h5 class="text-white">{{ item.empname }}</h5>
                                                    <small class="text-white">{{ item.dept_name }} • {{ item.vehicle_name }}</small>
                                                    <span class="badge bg-primary float-end text-white">{{ item.req_type }}</span>
                                                </div>
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Date:</strong> {{ item.schedule_checkout_date }}
                                                        </div>
                                                        <div>
                                                            <strong>Contact:</strong> {{ item.contact }}
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="mb-2">
                                                        <strong>Route:</strong> {{ item.source }} → {{ item.destination }}
                                                    </div>
                                                    
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Schedule Check Out:</strong> {{ item.schedule_checkout_time }}
                                                        </div>
                                                        <div>
                                                            <strong>Schedule Check In:</strong> {{ item.schedule_checkin_time }}
                                                        </div>
                                                    </div>
                                                    
                                                    <p><strong>Purpose:</strong> {{ item.purpose }}</p>
                                                    
                                                         <div>
                                                            
                                                            <div v-if="user.empdept == sd && item.checkout_date == null  && item.approval_status == 3">
                                                                <button title="Mark Check In" class="btn btn-primary"
                                                                  @click="mark_checkin(item.token, 2)">Check Out </button>
                                                            </div>
                                                            <div v-else>
                                                                <strong v-if="item.checkout_date">Security Checkout :</strong>  {{ item.checkout_date }}
                                                            </div>

                                                        
                                                            <div
                                                                v-if="user.empdept == sd && item.checkout_date != null && item.checkin_date == null ">
                                                                <button title="Mark Checkout" class="btn btn-primary"
                                                                    @click="mark_checkin(item.token, 1)">Check
                                                                    In</button>
                                                            </div>
                                                            <div v-else>
                                                                 <strong v-if="item.checkin_date">Security Checkin :</strong> {{ item.checkin_date }}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <span class="badge" :class="{
                                                                'bg-warning': item.approval_status==0 || item.approval_status==7,
                                                                'bg-success': item.approval_status==1 || item.approval_status==2 || item.approval_status==3,
                                                                'bg-danger': item.approval_status==4 || item.approval_status==5 || item.approval_status==6
                                                            }">
                                                                {{ getStatusText(item.approval_status) }}
                                                            </span>
                                                        </div><br>
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        
                                                        
                                                        <div class="action-buttons">
                                                            <button class="btn btn-sm btn-info me-1" v-if="item.approval_status>=1" @click="getQrCode(item.token)">
                                                                <i class="icofont icofont-qr-code"></i> QR
                                                            </button>
                                                            <button  v-if="(user.id == item.empid && item.approval_status==0)" class="btn btn-sm btn-danger me-1" @click="removeGatepass(item.id)">
                                                                <i class="icon-trash"></i> Delete
                                                            </button>
                                                            <button v-if="canTakeAction(item)"
                                                                class="btn btn-sm btn-success me-1" @click="accept(item.id)">
                                                                <i class="icofont icofont-ui-check"></i> Accept
                                                            </button>
                                                            <button v-if="canTakeAction(item)"
                                                                class="btn btn-sm btn-danger" @click="reject(item.id)">
                                                                <i class="icofont icofont-ui-close "></i> Reject
                                                            </button>
                                                        </div>
                                                    </div>
                                                    
                                                     
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Requested Vehicle Requests Card View -->
                            <div class="tab-pane fade  show active" id="requested" role="tabpanel" aria-labelledby="requested-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <!-- <h6 class="fw-bold">Pending For Approval:</h6> -->
                                        <h6 class="fw-bold">Today's Approval</h6>
                                          <div class="form-group d-flex align-items-center pb-2 gap-2">
                                          <input
                                            type="text"
                                            v-model="search_text_today"
                                            class="form-control"
                                            placeholder="Search..."
                                          />
                                        
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6" v-for="(item, index) in filterd_requested_req" :key="item.gatepassid">
                                            <div class="card mb-3">
                                                <div class="card-header" :class="{
                                                    'bg-warning': item.approval_status==0 || item.approval_status==7,
                                                    'bg-success': item.approval_status==1 || item.approval_status==2 || item.approval_status==3,
                                                    'bg-danger': item.approval_status==4 || item.approval_status==5 || item.approval_status==6
                                                }">
                                                    <h5 class="text-white">{{ item.empname }}</h5>
                                                    <small class="text-white">{{ item.dept_name }} • {{ item.vehicle_name }}</small>
                                                    <span class="badge bg-primary float-end text-white">{{ item.req_type }}</span>
                                                </div>
                                                <div class="card-body">
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Date:</strong> {{ item.schedule_checkout_date }}
                                                        </div>
                                                        <div>
                                                            <strong>Contact:</strong> {{ item.contact }}
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="mb-2">
                                                        <strong>Route:</strong> {{ item.source }} → {{ item.destination }}
                                                    </div>
                                                    
                                                    <div class="d-flex justify-content-between mb-2">
                                                        <div>
                                                            <strong>Schedule Check Out:</strong> {{ item.schedule_checkout_time }}
                                                        </div>
                                                        <div>
                                                            <strong>Schedule Check In:</strong> {{ item.schedule_checkin_time }}
                                                        </div>
                                                    </div>
                                                    
                                                    <p><strong>Purpose:</strong> {{ item.purpose }}</p>
                                                    
                                                         <div>
                                                            
                                                            <div v-if="user.empdept == sd && item.checkout_date == null  && item.approval_status == 3">
                                                                <button title="Mark Check In" class="btn btn-primary"
                                                                  @click="mark_checkin(item.token, 2)">Check Out </button>
                                                            </div>
                                                            <div v-else>
                                                               <strong v-if="item.checkout_date"> Security Checkout :</strong> {{ item.checkout_date }}
                                                            </div>

                                                        
                                                            <div
                                                                v-if="user.empdept == sd && item.checkout_date != null && item.checkin_date == null ">
                                                                <button title="Mark Checkout" class="btn btn-primary"
                                                                    @click="mark_checkin(item.token, 1)">Check
                                                                    In</button>
                                                            </div>
                                                            <div v-else>
                                                                <strong v-if="item.checkin_date">Security Checkin :</strong> {{ item.checkin_date }}
                                                            </div>
                                                        </div>
                                                    <div>
                                                            <span class="badge  "  :class="{
                                                    'bg-warning text-dark': item.approval_status==0 || item.approval_status==7,
                                                    'bg-success': item.approval_status==1 || item.approval_status==2 || item.approval_status==3,
                                                    'bg-danger': item.approval_status==4 || item.approval_status==5 || item.approval_status==6
                                                }">
                                                                {{ getStatusText(item.approval_status) }}
                                                            </span>
                                                        </div><br>
                                                        
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        
                                                        
                                                        <div class="action-buttons">
                                                            <button class="btn btn-sm btn-info me-1" v-if="item.approval_status>=1" @click="getQrCode(item.token)">
                                                                <i class="icofont icofont-qr-code"></i> QR
                                                            </button>
                                                            <button  v-if="(user.id == item.empid && item.approval_status==0)"  class="btn btn-sm btn-danger me-1" @click="removeGatepass(item.id)">
                                                                <i class="icofont icofont-trash"></i> Delete
                                                            </button>
                                                            <button v-if="canTakeAction(item)"
                                                                class="btn btn-sm btn-success me-1" @click="accept(item.id)">
                                                                <i class="icofont icofont-ui-check"></i> Accept
                                                            </button>
                                                            <button v-if="canTakeAction(item)"
                                                                class="btn btn-sm btn-danger me-1" @click="reject(item.id)">
                                                                 <i class="icofont icofont-ui-close"></i> Reject
                                                            </button>
                                                            <!--<button v-if="(user.emprole==1 && item.approval_status==1) || (item.approval_status==0 && user.emprole==2) || (item.approval_status==2 && user.emprole==4)" -->
                                                            <!--    class="btn btn-sm btn-info" @click="hold(item.id)">-->
                                                            <!--    <i class="fa fa-clock-o"></i>-->
                                                            <!--</button>-->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                           
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>






        <div v-else class="container-fluid">

            <div class="col-xxl-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                            data-original-title="test" data-bs-target="#vehicalReqAdd">Create Vehicle Request</button>
                    </div> -->
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active  nav-border txt-danger nav-danger" id="requested-tab"
                                    data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested"
                                    aria-selected="false"><i class="icofont icofont-file-document"></i>Today</a>
                            </li>
                            <li class="nav-item"><a class="nav-link nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a></li>
                            <!--<li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger"-->
                            <!--        id="completed-gatepass-tab" data-bs-toggle="tab" href="#completed-gatepass"-->
                            <!--        role="tab" aria-controls="completed-gatepass" aria-selected="false"><i-->
                            <!--            class="icofont icofont-star"></i>Completed</a></li>-->

                                        <li>  <button class="btn btn-primary" type="button" data-bs-toggle="modal"
                                            data-original-title="test" data-bs-target="#vehicalReqAdd">Create Vehicle Request</button> </li>
                        </ul>
                        <div class="tab-content" id="topline-tabContent">
                            <div class="tab-pane fade " id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">


                             


                                    <div class="user-header pb-2 mt-2">
                                        <h6 class="fw-bold">All Vehicle Request:</h6>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display" id="all_table">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th> 
                                                        <th>Employee Name</th>
                                                        <th>Department</th>
                                                        <th>Vehicle Details</th>
                                                        <th>Source</th>
                                                        <th>Destination</th>
                                                        <th>Contact</th>
                                                        <th>Purpose</th> 
                                                        <th>Schedule Check Out</th>
                                                        <th>Schedule Check In</th>
                                                        <th>Security Check Out</th>
                                                        <th>Security Check In</th>
                                                        <th>Active Time</th>
                                                        <th>Approval Status</th>
                                                        <th >Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in filterd_request" :key="item.gatepassid">
                                                       <td>{{ item.schedule_checkout_date }} </td>
                                                        <td>{{ item.empname }} <span class="badge-sm bg-primary">{{ item.req_type }}</span> </td>
                                                        <td>{{ item.dept_name }} </td>
                                                        <td>{{ item.vehicle_name }} </td>
                                                        <td>{{ item.source }}</td>
                                                        <td>{{ item.destination }}</td>
                                                        <td>{{ item.contact }}</td>
                                                        <td>{{ item.purpose }}  </td>
                                                         
                                                        <td>{{ item.schedule_checkout_date+' - '+item.schedule_checkout_time  }}</td>
                                                        <td>{{ item.schedule_checkin_date+' - '+item.schedule_checkin_time  }}</td>
                                                        <td>
                                                            
                                                            <div v-if="user.empdept == sd && item.checkout_date == null  && item.approval_status == 3">
                                                                <button title="Mark Check In" class="btn btn-primary"
                                                                  @click="mark_checkin(item.token, 2)">Check Out </button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.checkout_date }}
                                                            </div>

                                                        </td>
                                                        <td>
                                                            <div
                                                                v-if="user.empdept == sd && item.checkout_date != null && item.checkin_date == null ">
                                                                <button title="Mark Checkout" class="btn btn-primary"
                                                                    @click="mark_checkin(item.token, 1)">Check
                                                                    In</button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.checkin_date }}
                                                            </div>
                                                        </td>
                                                          <td>

                                                           

                                                                <template v-if="item.checkin_date">
                                                                     {{ timeDiff(item.checkout_date, item.checkin_date) }} 
                                                                </template>
                                                                  <template v-else-if="!item.checkout_date && !item.checkin_date">
                                                                  0
                                                                </template>
                                                                <template v-else-if="item.checkout_date && !item.checkin_date">
                                                                    {{ getCheckInDiff(item.checkout_date) }}
                                                                </template>
                                                                </td>

                                                        <td> 
                                                            <!--<div v-if="item.approval_status==0" class="badge bg-warning">Pending</div>-->
                                                            <!--<div v-else-if="item.approval_status==1" class="badge bg-success">HOD Approved</div>-->
                                                            <!--<div v-else-if="item.approval_status==2" class="badge bg-success">HR Approved</div>-->
                                                            <!--<div v-else-if="item.approval_status==3" class="badge bg-success">Security Approved</div>-->
                                                            <!--<div v-else-if="item.approval_status==4" class="badge bg-danger">HOD Declined</div>-->
                                                            <!--<div v-else-if="item.approval_status==5" class="badge bg-danger">HR Declined</div>-->
                                                            <!--<div v-else-if="item.approval_status==6" class="badge bg-danger">Security Declined</div>-->
                                                            <!--<div v-else-if="item.approval_status==7" class="badge bg-warning">On Hold</div>-->
                                                             <div>
                                                                    <span class="badge" :class="{
                                                                        'bg-warning': item.approval_status==0 || item.approval_status==7,
                                                                        'bg-success': item.approval_status==1 || item.approval_status==2 || item.approval_status==3,
                                                                        'bg-danger': item.approval_status==4 || item.approval_status==5 || item.approval_status==6
                                                                    }">
                                                                        {{ getStatusText(item.approval_status) }}
                                                                    </span>
                                                                </div>
                                                        </td>
                                                        <td>
                                                            <ul class="action">
                                                              
                                                                <li class="link" @click="getQrCode(item.token)"><i
                                                                        class="icofont icofont-qr-code"></i></li> 
                                                                <li class="delete"  v-if="(user.id == item.empid && item.approval_status==0)" 
                                                                    @click="removeGatepass(item.id)"><i
                                                                        class="icon-trash"></i></li>
                                                                        <li v-if="canTakeAction(item)" title="Accept"
                                                                    @click="accept(item.id)">
                                                                             <i class="icofont icofont-ui-check text-success"></i>
                                                                                <!--<i class="icon-check text-success"></i>-->
                                                                            </li>
                                                                <li v-if="canTakeAction(item)" title="Decline"
                                                                    @click="reject(item.id)">
                                                                    <i class="icofont icofont-ui-close text-danger"></i>
                                                                    <!--<i class="icon-close text-danger"></i>-->
                                                                    
                                                                    </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade show active" id="requested" role="tabpanel" aria-labelledby="requested-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <!-- <h6 class="fw-bold">Pending For Approval:</h6> -->
                                        <h6 class="fw-bold">Today's List</h6>
                                    </div>
                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display" id="pending_table">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th> 
                                                        <th>Employee Name</th>
                                                        <th>Department</th>
                                                        <th>Vehicle Details</th>
                                                        <th>Source</th>
                                                        <th>Destination</th>
                                                        <th>Contact</th>
                                                        <th>Purpose</th> 
                                                        <th>Schedule Check Out</th>
                                                        <th>Schedule Check In</th>
                                                        <th>Security Check Out</th>
                                                        <th>Security Check In</th>
                                                        <th>Active Time</th>
                                                        <th>Approval</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in filterd_requested_req" :key="item.gatepassid">
                                                        <td>{{ item.schedule_checkout_date }} </td>
                                                        <td>{{ item.empname }}  <span class="badge-sm bg-primary">{{ item.req_type }}</span>  </td>
                                                        <td>{{ item.dept_name }} </td>
                                                        <td>{{ item.vehicle_name }} </td>
                                                        <td>{{ item.source }}</td>
                                                        <td>{{ item.destination }}</td>
                                                        <td>{{ item.contact }}</td>
                                                        <td>{{ item.purpose }}  </td>
                                                         
                                                        <td>{{ item.schedule_checkout_date+' - '+item.schedule_checkout_time  }}</td>
                                                        <td>{{ item.schedule_checkin_date+' - '+item.schedule_checkin_time  }}</td>
                                                        <td>
                                                            
                                                            <div v-if="user.empdept == sd && item.checkout_date == null  && item.approval_status == 3">
                                                                <button title="Mark Check In" class="btn btn-primary"
                                                                  @click="mark_checkin(item.token, 2)">Check Out </button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.checkout_date }}
                                                            </div>

                                                        </td>
                                                        <td>
                                                            <div
                                                                v-if="user.empdept == sd && item.checkout_date != null && item.checkin_date == null  ">
                                                                <button title="Mark Checkout" class="btn btn-primary"
                                                                    @click="mark_checkin(item.token, 1)">Check
                                                                    In</button>
                                                            </div>
                                                            <div v-else>
                                                                {{ item.checkin_date }}
                                                            </div>
                                                        </td>
                                                        
                                                            <td>

                                                           

                                                                <template v-if="item.checkin_date">
                                                                     {{ timeDiff(item.checkout_date, item.checkin_date) }} 
                                                                </template>
                                                                  <template v-else-if="!item.checkout_date && !item.checkin_date">
                                                                  0
                                                                </template>
                                                                <template v-else-if="item.checkout_date && !item.checkin_date">
                                                                    {{ getCheckInDiff(item.checkout_date) }}
                                                                </template>
                                                                </td>
                                                        <td>
                                                            <!--<div v-if="item.approval_status==0" class="badge bg-warning">Pending</div>-->
                                                            <!--<div v-else-if="item.approval_status==1" class="badge bg-success">HOD Approved</div>-->
                                                            <!--<div v-else-if="item.approval_status==2" class="badge bg-success">HR Approved</div>-->
                                                            <!--<div v-else-if="item.approval_status==3" class="badge bg-success">Security Approved</div>-->
                                                            <!--<div v-else-if="item.approval_status==4" class="badge bg-danger">HOD Declined</div>-->
                                                            <!--<div v-else-if="item.approval_status==5" class="badge bg-danger">HR Declined</div>-->
                                                            <!--<div v-else-if="item.approval_status==6" class="badge bg-danger">Security Declined</div>-->
                                                            <!--<div v-else-if="item.approval_status==7" class="badge bg-warning">On Hold</div>-->
                                                            
                                                             <div>
                                                                    <span class="badge" :class="{
                                                                        'bg-warning': item.approval_status==0 || item.approval_status==7,
                                                                        'bg-success': item.approval_status==1 || item.approval_status==2 || item.approval_status==3,
                                                                        'bg-danger': item.approval_status==4 || item.approval_status==5 || item.approval_status==6
                                                                    }">
                                                                        {{ getStatusText(item.approval_status) }}
                                                                    </span>
                                                                </div>
                                                        </td>
                                                        <td>
                                                            <ul class="action">
                                                                <li class="delete" v-if="(user.id == item.empid && item.approval_status==0)" 
                                                                    @click="removeGatepass(item.gatepassid)" ><i
                                                                        class="icon-trash"></i></li>
                                                                        <li v-if="canTakeAction(item)" title="Accept"
                                                                    @click="accept(item.id)">
                                                                            <!--<i class="icon-check text-success"></i>-->
                                                                             <i class="icofont icofont-ui-check text-success"></i>
                                                                        </li>
                                                                <li v-if="canTakeAction(item)" title="Decline"
                                                                    @click="reject(item.id)">
                                                                     <i class="icofont icofont-ui-close text-danger"></i>
                                                                   </li>  
                                                                <!--<li v-if="(user.emprole==1 && item.approval_status==1) || (item.approval_status==0 &&  user.emprole==2) || (item.approval_status==2 &&  user.emprole==4)" title="Hold"-->
                                                                <!--    @click="hold(item.id)"><i-->
                                                                <!--        class="fa fa-clock-o text-info"></i></li>-->
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
     
    <div class="modal fade" id="qrcodeView" tabindex="-1" role="dialog" aria-labelledby="qrcodeView"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">QR Code</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                          <canvas ref="qrcodeCanvas"></canvas>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                       
                    </div>
                </div>
            </div>
        </div>
    </div>




<!-- start Model -->
<div class="modal" v-if="showfilterModel" style="display: block; background-color: rgba(0,0,0,0.5);" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Filter</h5>
          <button type="button" class="close" @click="showfilterModel = false" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

            <div class="col-12 row" >


                <div class="col-6">
                <label class="form-label">From Date</label>
                <input class="form-control" type="date" 
                    v-model="filter.fromdate" placeholder="Type Here..." required>
                </div>

                <div class="col-6">
                    <label class="form-label">To Date</label>
                    <input class="form-control" type="date" 
                        v-model="filter.todate" placeholder="Type Here..." required>
                    </div>
                </div>

                <div class="col-12 row" >

                   <div class="col-6">
                    <label class="form-label">Employee Name</label>   
                    <Autocomplete 
                          :items="employees" 
                          labelField="empname" 
                          valueField="id"
                          placeholder="Search Employee"
                          @select="handleSelectEmp" />

                          </div>

                          <div class="col-6">
                        <label class="form-label">Department Name</label>   
                        <Autocomplete 
                              :items="dept" 
                              labelField="deptname" 
                              valueField="id"
                              placeholder="Search Department"
                              @select="handleSelectDept" />

                              </div>
    
                

                            </div>      

        </div>
        <div class="modal-footer">
        
          <button type="button" class="btn btn-primary" @click="getfilterlist">Filter</button>
        </div>
      </div>
    </div>
  </div>
 <!-- end Model -->







    <ModalsPart v-if="!['login'].includes($route.name)" @getVehReqData="updateData"  />
</template>
<style scoped>
.avatar {
    width: 50px;
    border-radius: 30px;
}
.badge-sm{
    padding: 2px 7px;
    border-radius: 10px; 
}
ul{
        gap: 4px;
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'VehicalRequest',
    components: {
        PageTitle, ModalsPart,GatePass
    }, mounted() {
          if (this.$route.query.q) 
            this.getBasics({filter:this.$route.query.q});
         else if (this.$route.query.visitorid) 
            this.getBasics({visitorid:this.$route.query.visitorid});
         else
            this.getBasics();

    },
    watch:
    {
         search_text_all(newVal) {
             this.onSearchTypeAll(newVal);
         },
         search_text_today(newVal) {
              this.onSearchTypeToday(newVal);
         },
         
          request(newVal) {
             if (newVal) this.filterd_request=newVal;
          
            },
    
    requested_req(newVal) {
            if (newVal)  this.filterd_requested_req=newVal;
          }
          
          
    },
    data() {
        return {
            filter:{
                fromdate:this.todayDate(),
                todate:this.todayDate(),
                empid:'',
                deptid:'',
            },
            user: [],
            request: [],
            requested_req: [],
            completed_req: [],
            rooms:[],
            room_booking_visitor:[],
            selected_room:{'roomid':0,'gatepassid':0,'schedule_date':'','schedule_time':''},
            showfilterModel:false,
            sd:0,
            dept:[],
            employees:[],
            search_text_all:'',
            search_text_today:'',
            filterd_requested_req:[],
            filterd_request:[]
        }
    },
    methods: {
            
        updateData(datahere) {
              var self = this;
            // axios.post('getVehicleRequest').then(function (response) {
                self.destroyTable();
                self.$nextTick(() => { 
                    self.request = datahere.request;
                    self.completed_req = datahere.completed_req;
                    self.requested_req = datahere.requested_req; 
                    self.user = datahere.user; 
                });
                self.refreshTable();
            //     window.scrollTo(0, 0);
            // }).then(() => {
            //                     self.refreshTable();
            //                 });
        },
        getBasics(filter) {
            var self = this;
            axios.post('getVehicleRequest',filter).then(function (response) {
                  self.destroyTable();
                self.request = response.data.request;
                self.completed_req = response.data.completed_req;
                self.requested_req = response.data.requested_req; 
                self.user = response.data.user; 
                self.sd = response.data.sd; 
                self.dept = response.data.dept;
                self.employees = response.data.employees;
            



                // window.scrollTo(0, 0);
            }).then(() => {
                self.refreshTable();
            });
        },
        
           destroyTable(){ 
                if ($.fn.dataTable.isDataTable('#completed_table')) {
                                    $('#completed_table').DataTable().destroy();
                                }
                if ($.fn.dataTable.isDataTable('#all_table')) {
                                    $('#all_table').DataTable().destroy();
                                }
                if ($.fn.dataTable.isDataTable('#pending_table')) {
                                    $('#pending_table').DataTable().destroy();
                                }
            },
    refreshTable(){
        var self=this; 
                    this.$nextTick(() => { 
                            $("#completed_table").DataTable({
                                dom: 'Bfrtip',
                                buttons: ['excel', 'pdf'],
                                "paging": true,
                                "ordering": true,
                                "autoWidth": false
                            });
                            $("#all_table").DataTable({
                                dom: 'Bfrtip',
                                buttons: ['excel', 'pdf',{
                                                        text: 'Filter',
                                                        action: function (e, dt, node, config) {
                                                          self.filterlist();
                                                        }}],
                                "paging": true,
                                "ordering": true,
                                "autoWidth": false
                            });
                            $("#pending_table").DataTable({
                                dom: 'Bfrtip',
                                buttons: ['excel', 'pdf'],
                                "paging": true,
                                "ordering": true,
                                "autoWidth": false
                            });
                    });
    },
    
    
        removeGatepass(id) {
            var self = this;
            self.$swal({
                title: "Do You Want To Delete?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                    axios.post('removeVehicleRequest', { gatepass_id: id }).then(function (response) {
                        
                        self.$swal(response.data.msg);
                        if(response.data.is==1){
                         self.destroyTable();
                         self.request = response.data.request;
                                    self.completed_req = response.data.completed_req;
                                    self.requested_req = response.data.requested_req; 
                                    self.user = response.data.user; 
                        }
                        // self.request = response.data.request;
                        window.scrollTo(0, 0);
                    }).then(() => {
                                self.refreshTable();
                            });
                }
            });

        },
        accept(veh_req_id) {
            var self = this;
            self.$swal({
                title: "Do You Want To Accept?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                    axios.post('acceptVehicleGatepass', { veh_req_id: veh_req_id }).then(function (response) {
                        self.destroyTable();
                                    self.request = response.data.request;
                                    self.completed_req = response.data.completed_req;
                                    self.requested_req = response.data.requested_req; 
                                    self.user = response.data.user; 
                        window.scrollTo(0, 0);
                    }).then(() => {
                                self.refreshTable();
                            });
                }
            });

        },
        reject(veh_req_id) {
            var self = this;
            self.$swal({
                title: "Do You Want To Decline?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                    axios.post('acceptVehicleGatepass', { veh_req_id: veh_req_id,reject:1 }).then(function (response) {
                        self.destroyTable();
                                    self.request = response.data.request;
                                    self.completed_req = response.data.completed_req;
                                    self.requested_req = response.data.requested_req; 
                                    self.user = response.data.user; 
                        window.scrollTo(0, 0);
                    }).then(() => {
                                self.refreshTable();
                            });
                }
            });

        },
        hold(veh_req_id) {
            var self = this;
            self.$swal({
                title: "Do You Want To Hold?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                    axios.post('acceptVehicleGatepass', { veh_req_id: veh_req_id,hold:7}).then(function (response) {
                        self.destroyTable();
                                    self.request = response.data.request;
                                    self.completed_req = response.data.completed_req;
                                    self.requested_req = response.data.requested_req; 
                                    self.user = response.data.user; 
                        window.scrollTo(0, 0);
                    }).then(() => {
                                self.refreshTable();
                            });
                }
            });

        },
        async getQrCode(token) {
            try {
              if(token.length>0){
                  const canvas = this.$refs.qrcodeCanvas;
                 var url=this.$api_host+'vr?q='+token;
                 //var url='http://192.168.1.8:8081/vehiclepassview?q='+token;
                  await QRCode.toCanvas(canvas,url , { width: 200 });
                  $("#qrcodeView").modal("toggle");
              }
              
            } catch (error) {
              console.error(error);
            }
          },
        getImageUrl(image) {
            return `${this.$hostname}/writable/visitors/${image}`;
        },



  



    todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },





            isMobileView() {
      if (window.innerWidth <= 768) {
        //   alert("Yes");
        return true;
        } else {
            // alert("No");
          return false;
        }
      },


      getStatusText(status) {
               
                const statusNum = Number(status);
                
                switch(statusNum) {
                    case 0: return 'Pending';
                    case 1: return 'HOD Approved Pending For HR';
                    case 2: return 'HR Approved  Pending For Security';
                    case 3: return 'Security Approved';
                    case 4: return 'HOD Declined';
                    case 5: return 'HR Declined';
                    case 6: return 'Security Declined';
                    case 7: return 'On Hold';
                    default: return 'Unknown Status (' + status + ')'; // Show the actual value for debugging
                }
            },


            filterlist(){


            this.showfilterModel=true;


            },

            getfilterlist() {
            var self = this;
            axios.post('filterVehicleRequest',self.filter).then(function (response) {
                self.destroyTable();
                self.request = response.data.request;
                self.completed_req = response.data.completed_req;
                self.requested_req = response.data.requested_req; 
                self.user = response.data.user; 


                self.status = response.data.status;


                        if(self.status == 1){
                            self.$swal("Filtered")
                            self.showfilterModel=false;

                        }







                // window.scrollTo(0, 0);
            }).then(() => {
                self.refreshTable();
            });
        },



//08.05.2025
   mark_checkin(passid,what) {
            var self = this;
            self.$swal({
                title: "Do You Want To proceed ?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                
                    
            
                    const formData = new FormData();
                     
                    formData.append('passid', passid);
                    formData.append('what', what);
                    
                    axios.post('VehiclecheckInUser', formData).then(function (response) {
                        if(response.data.is==1){
                           self.destroyTable();
                            self.request = response.data.request;
                            self.completed_req = response.data.completed_req;
                            self.requested_req = response.data.requested_req; 
                            self.user = response.data.user;  
                        //   self.showimgModal=false;
                        }
                            self.$swal(response.data.gatepassReq);
                    }).then(() => {
                            self.refreshTable();
                        });
                }
            });

        },

  getCheckInDiff(checkIn) {
                    const checkInDate = new Date(checkIn);
                    const now = new Date();
                    const diffMs = now - checkInDate; // Difference in milliseconds

                    // Convert to more readable format (e.g., hours and minutes)
                    const diffMins = Math.floor(diffMs / 60000);
                    const hours = Math.floor(diffMins / 60);
                    const minutes = diffMins % 60;
                    if(hours>0 || minutes>0)
                        return `${hours}h ${minutes}m ago`;
                    else
                        return '';
                },




            
        
          timeDiff(start, end) {
              if(!end || end<=start)
                return "";
                // Calculate difference in milliseconds
                const diffMs = new Date(end) - new Date(start);
                
                // Convert to hours and minutes
                const hours = Math.floor(diffMs / (1000 * 60 * 60));
                const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                
                // Return as an object or formatted string
                 
                 return (hours?hours+" Hr,":'')+(minutes?minutes+" Min":'');
                    
                
                // Or return as a formatted string:
                // return `${hours}h ${minutes}m`;
            },
            
            handleSelectEmp(selectedEmp) {
             this.filter.empid= selectedEmp.id;
    },


            handleSelectDept(selectedDept) {
            this.filter.deptid= selectedDept.id;
    },
 canTakeAction(item) {
    return (
      (this.user.emprole == 1 && item.approval_status == 1) ||
      (item.approval_status == 0 && this.user.emprole == 2) ||
      ((item.approval_status == 7 || item.approval_status == 2) && this.user.emprole == 4)
    );
  },
   onSearchTypeAll(query) {
               if(query.length>0){
                        this.filterd_request = this.request.filter(item =>
                          item.empname.toLowerCase().includes(query.toLowerCase()) ||
                          item.dept_name.toLowerCase().includes(query.toLowerCase())||
                          item.empcode.toLowerCase().includes(query.toLowerCase())
                        );
                       }else{
                                  this.filterd_request = this.request;
                             }
              }
              ,
               onSearchTypeToday(query) {
                
                if(query.length>0){
                        this.filterd_requested_req = this.requested_req.filter(item =>
                          item.empname.toLowerCase().includes(query.toLowerCase())||
                          item.dept_name.toLowerCase().includes(query.toLowerCase())||
                          item.empcode.toLowerCase().includes(query.toLowerCase())
                        );
                        }else{
                                          this.filterd_requested_req = this.requested_req;
                                     }
              },

    }
}
</script>
